<ng-container *ngIf="(model?.Handlings ?? []).length">

  <div class="module-create-handlings-cntr">

    <!-- SEZIONE MOVIMENTAZIONI TRA DEPOSITI -->
    <ng-container *ngIf="handlings.length">

      <h3 class="section-title">{{ getMovementTitle() | translate }}</h3>
      <p class="section-message">{{ getMovementMessage() | translate }}</p>

      <app-module-item-order 
        #moduleItemOrder 
        [handlings]="handlings">
      </app-module-item-order>

      <!-- Divider se ci sono anche ordini -->
      <mat-divider *ngIf="orders.length" style="margin: 20px 0;"></mat-divider>

    </ng-container>

    <!-- SEZIONE ORDINI AI FORNITORI -->
    <ng-container *ngIf="orders.length">

      <h3 class="section-title">{{ getOrderTitle() | translate }}</h3>
      <p class="section-message">{{ getOrderMessage() | translate:getOrderMessageParams() }}</p>

      <app-module-item-order 
        #moduleItemOrder 
        [model]="model" 
        [handlings]="orders">
      </app-module-item-order>

      <mat-divider style="margin: 20px 0;"></mat-divider>

      <!-- NOTA CONTESTUALE: Solo per moduli (Origin === 3) -->
      <small *ngIf="shouldShowModuleNote()" class="context-note">
        {{ "ModuleCreateHandlings.NoteAfterOrders" | translate }}
      </small>

    </ng-container>

  </div>

  <!-- MESSAGGIO DI CONFERMA FINALE -->
  <p class="confirm-message">
    {{ getConfirmMessage() | translate }}
  </p>

</ng-container>

<ng-container *ngIf="(model?.Messages ?? []).length">

  <p> {{ "moduleCreateMessages" | translate }} </p>

    <ul>

      <li *ngFor="let message of model?.Messages"> {{ message }}</li>

    </ul>

  </ng-container>


<ng-container *ngIf="(model?.Errors ?? []).length">

  <p> {{ "moduleCreateErrors" | translate }} </p>

    <ul>

      <li *ngFor="let error of model?.Errors"> {{ error }}</li>

    </ul>

 </ng-container>

